import styled from 'styled-components'

export const Section = styled.section`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0 8px;

  label {
    font-size: 16px;
    font-weight: 700;
  }
`
